type GetUnhandledErrorEventsToIgnore = () => string[];

export const getUnhandledErrorEventsToIgnore: GetUnhandledErrorEventsToIgnore = () => [
  'ResizeObserver loop limit exceeded',
];
